import React,{useState,useEffect} from 'react'
import HeaderofAdash from '../subComponent/HeaderofAdash'
import SidebarOfAdash from '../subComponent/SidebarOfAdash'
import {Row,Col,Modal,Form} from 'react-bootstrap'

import Switch from '../desktop/subComponent/Switch'
import Purplebutton from '../desktop/subComponent/Purplebutton'
const SettingCompmb = () => {
    const [buttonStates, setButtonStates] = useState({
        button1:false,
        button2:false,
        button3:false,
        button4:false,
        button5:false,
        button6:false,
        button7:false,
        button8:false,
        button9:false,

    });

  const handleButtonStateChange = (buttonId, isChecked) => {
    // Update the state with the new isChecked value for the specific button
    setButtonStates((prevState) => ({
      ...prevState,
      [buttonId]: isChecked,
    }));
  };
  useEffect(()=>{
      console.log(buttonStates)

  },[buttonStates])

  const handlesave=()=>{

  }
  return (
    <>
    <div className="felxvaluecompmbmain">
        <div className="studentdashboardmobilewrapper">
            <div className="mobilecontainer">
                <div className="adminmbheading">
                    <h3>Setting</h3>
                </div>
                <div className="admbwrap pb0">
                    <Row>
                    <Col xs={12}>
                    <div className="contentofadmindash settingwhite settingwhitemb">

                    <ul>
                        <li>
                            <p>
                        Set, if late fee will enable or disable during taking student tuition fee. (Online payment)

                            </p>
                            <Switch id="button1" func={handleButtonStateChange} />
                            
                        </li>
                        <li>
                            <p>Publish first semester assessment results on the student panel. (Enable will publish the result)</p>
                        <Switch id="button2" func={handleButtonStateChange} />
                        </li>
                        <li>
                            <p>Publish second semester assessment results on the student panel. (Enable will publish the result)</p>
                        <Switch id="button3" func={handleButtonStateChange} />
                        </li>
                        <li>
                            <p>Publish first semester exam results on the student panel. (Enable will publish the result)</p>
                        <Switch id="button4" func={handleButtonStateChange} />
                        </li>
                        <li>
                            <p>Publish second semester exam results on the student panel. (Enable will publish the result)</p>
                        <Switch id="button5" func={handleButtonStateChange} />
                        </li>
                        <li>
                            <p>Publish first semester exam results on the student panel. (Pre- O Level & O Level)</p>
                        <Switch id="button6" func={handleButtonStateChange} />
                        </li>
                        <li>
                            <p>Publish second semester exam results on the student panel. (Pre- O Level & O Level)</p>
                        <Switch id="button7" func={handleButtonStateChange} />
                        </li>
                        <li>
                            <p>Student result position in class in first semester show or hide from result card. (Enable will show the position)</p>
                        <Switch id="button8" func={handleButtonStateChange} />
                        </li>
                        <li>
                            <p>Student result position in class in second semester show or hide from result card. (Enable will show the position)</p>
                        <Switch id="button9" func={handleButtonStateChange} />
                        </li>
                    </ul>

                    <div className="savebutton text-center">
                        <Purplebutton clickfunc={handlesave} btnname="Save" w="117px" h="40px" mt="20px"/>
                    </div>
                    </div>
                    </Col>
                    </Row>
                </div>
            </div>
        </div>
    </div>
    </>
  )
}

export default SettingCompmb